<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer">
      <div class="ir-content--modal th-content">
        <div class="ir-item-line th-filter-modal">
          <div class="ir-item-cell s1 clickable">
            <span><i class="material-icons">arrow_drop_up</i>N°</span>
          </div>
          <div class="ir-item-cell s8 clickable">
            <span><i class="material-icons">arrow_drop_up</i>{{ 'plugins.observation.name' | translate }}</span>
          </div>
          <div class="ir-item-cell s1 clickable">
            <span><i class="material-icons">arrow_drop_up</i>{{ 'plugins.observation.status' | translate }}</span>
          </div>
        </div>
        <div class="ir-content-flow has-filter has-footer th-content-flow--dark">
          <div *ngIf="observationsAndRecommandations">
            <div
              class="ir-item-line th-inspection clickable"
              (click)="openEditObservation(i)"
              *ngFor="let item of observationsAndRecommandations; let i = index"
            >
              <div class="ir-item-cell s1 {{ item.Selected ? 'important' : '' }}">
                <span>{{ i + 1 }}</span>
              </div>
              <div class="ir-item-cell s8 {{ item.Selected ? 'important' : '' }}">
                <span innerHtml="{{ item.Observation }}" class="noellipsis"></span>
              </div>
              <div class="ir-item-cell s1 {{ item.Selected ? 'important' : '' }}">
                <span *ngIf="item.Selected">{{ 'plugins.observation.active' | translate }}</span>
                <span *ngIf="!item.Selected">{{ 'plugins.observation.inactive' | translate }}</span>
              </div>
            </div>
            <div class="ir-item-empty ir-mv8" *ngIf="observationsAndRecommandations?.length == 0">
              <p>
                <span
                  >{{ 'plugins.observation.no-observation' | translate }}<br />{{
                    'plugins.observation.can-add-observation' | translate
                  }}</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<edit-observation
  #editObservation
  (toggleRemove)="removeObservation()"
  (toggleSave)="saveObservation($event)"
  (toggleCancel)="cancel()"
  [responsibles]="responsibles"
  [priorities]="priorities"
  [machines]="machines"
></edit-observation>
<add-observation
  #addObservation
  [title]="'Add an observation'"
  (toggleSave)="saveAddObservation()"
  (toggleCancel)="cancel()"
></add-observation>
